module.exports = __webpack_public_path__ + "img/6ea4c44eec0241f84f45ea3e4a9bcea5.png";